export default __webpack_public_path__ + "static/media/MagnusLogo.bf72d271.png";